// extracted by mini-css-extract-plugin
module.exports = {"list-choice":"bet-history_list-choice__l2zjA","choice":"bet-history_choice__3Y3ti","bet-amount":"bet-history_bet-amount__2sQQE","w-result":"bet-history_w-result__1gxUl"};